<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
          <a-form-item label="关键字">
              <a-input  v-model="searchP.keyword"  placeholder="编码/名称" ></a-input>
          </a-form-item>

          <a-form-item label="通道类型">
                <passwayTypeSelecter :showAll="true" :isdisable="false" @passwayTypeChange="handleChange"></passwayTypeSelecter>

          </a-form-item>

          <a-form-item>
                <a-button type="primary"  @click="handleSubmit">查询</a-button>
          </a-form-item>
      </a-form>
</template>

<script>
import passwayTypeSelecter from '../../components/passwaytypeSelecter'

export default {
    components:{
        passwayTypeSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                keyword:'',
                passwaytype:''
            },
        }
    },
    methods:{
        handleChange(item){
            this.searchP.passwaytype = item.passwaytype;
        },
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

